<div class="page-title-wrapper d-flex">
  <div class="container d-flex align-items-center">
    <a [routerLink]="[backLink]" *ngIf="showBackLink">
      <img lib-amdocs-image-version class="back-arrow" src="/assets/icons/arrrowLeft.svg"/>
    </a>
    <div class="label-h1">{{pageTitle | amdocsTranslate}}</div>

  </div>
</div>
